const { Role } = require('@/lib/business');

class UserGroup {
  userGroupId = 0;

  name = '';

  deploymentIndexId = 0;

  roleId = 0;

  role = null;

  constructor(userGroup) {
    this.userGroupId = userGroup.userGroupId;
    this.name = userGroup.name;
    this.deploymentIndexId = userGroup.deploymentIndexId;
    this.roleId = userGroup.roleId;
    this.role = new Role(userGroup.role);
  }

  static fromObject(data) {
    return new UserGroup(data);
  }

  static fromList(list) {
    return (list || []).map(UserGroup.fromObject);
  }
}

export default UserGroup;
